import { render, staticRenderFns } from "./ActionPopover.vue?vue&type=template&id=78195a51"
import script from "./ActionPopover.vue?vue&type=script&lang=js"
export * from "./ActionPopover.vue?vue&type=script&lang=js"
import style0 from "./ActionPopover.vue?vue&type=style&index=0&id=78195a51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports